import AccountIcon from '../../components/AccountIcon'
import { formatCurrency, formatDate } from '../../Helpers'
import { addImpacts, applyImpact, formatImpact } from '../../Impact'

interface Props {
    bankTransaction: BankTransaction
    suggestion: LinkSuggestion
    accounts: Account[]
    budgets: Budget[]
    onClick: () => void
}

// Lien évident : « Lier · Pizzas » fusionne en un clic. Au survol, l'opération trouvée et ce que
// donne la fusion (mêmes règles que la fenêtre de liaison, sans choix à faire).
const QuickLinkButton = ({ bankTransaction, suggestion, accounts, budgets, onClick }: Props) => {
    const account = accounts.find((account) => account.id === suggestion.account_id)
    const budgetName = (id: number | null) => (id && budgets.find((budget) => budget.id === id)?.name) || null
    const otherFromBank = account?.synced && !account.tricount
    // La part vient de l'opération absorbée, le budget de celle qui en a un.
    const impact = otherFromBank ? bankTransaction.impact : suggestion.impact
    const budget = budgetName(bankTransaction.budget_id || suggestion.budget_id)
    const amount = bankTransaction.amount_cents

    return <button className="quick-link" onClick={onClick}>
        { account && <AccountIcon account={account} size={16}/> }
        <span className="name">Lier · { suggestion.label }</span>
        <span className="quick-link-popover tl-card">
            <small>Lien évident</small>
            <span className="other">
                { account && <AccountIcon account={account} size={28}/> }
                <span className="t">
                    <b>{ suggestion.label }</b>
                    <span>{ formatDate(suggestion.at) } · { account?.name } · part { formatImpact(suggestion.impact) }</span>
                </span>
                <span className="m">{ formatCurrency(amount) }</span>
            </span>
            <span className="effect">
                Même montant, à un jour près, seul candidat. Après le lien : { formatImpact(impact) }{ budget && <> dans { budget }</> },
                soit <b>{ formatCurrency(Math.round(applyImpact(amount, impact))) }</b> dans les budgets
                au lieu de { formatCurrency(Math.round(applyImpact(amount, addImpacts(bankTransaction.impact, suggestion.impact)))) }.
            </span>
        </span>
    </button>
}

export default QuickLinkButton
